import api from '../api/axios';
import { ExpedientesGuardados, ResultadoExpediente, ResultadoGuardado } from '../types/expediente';

export const expedienteService = {
  /** Última foto guardada de esos RUTs (con `fresco`, que decide a quién se vuelve a consultar). */
  guardados: async (ruts: number[]): Promise<ExpedientesGuardados> => {
    const { data } = await api.get<ExpedientesGuardados>('coordinacion/expedientes/', {
      params: { ruts: ruts.join(',') },
    });
    return data;
  },

  /**
   * Consulta UCampus por UNA persona. No guarda nada.
   *
   * Va de a uno porque UCampus responde de a uno: quien llama encadena la lista,
   * así el avance se ve mientras corre y un RUT que falla no arrastra al resto.
   * La cookie viaja en el cuerpo (no en la URL) y el backend no la guarda.
   */
  extraer: async (rut: number, cookie: string): Promise<ResultadoExpediente> => {
    const { data } = await api.post<ResultadoExpediente>('coordinacion/expedientes/extraer/', { rut, cookie });
    return data;
  },

  /** Guarda las fotos que el coordinador confirmó. */
  guardar: async (resultados: ResultadoExpediente[]): Promise<ResultadoGuardado> => {
    const { data } = await api.post<ResultadoGuardado>('coordinacion/expedientes/', { resultados });
    return data;
  },
};
